import React, { Component } from 'react';
import { Col, Button, Form, FormGroup, Input, Label, Container, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

class MappingTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mappings: [],
            stateAlreadyCopiedFromProps: false
        }
        this.changePosTypeState = this.changePosTypeState.bind(this);
        this.updateMappingType = this.updateMappingType.bind(this);
    }

    copyStateFromProps() {
        const { mappingTypes } = this.props;

        if (mappingTypes !== undefined && mappingTypes !== null && mappingTypes.length > 0 && !this.state.stateAlreadyCopiedFromProps) {

            const newMappings = [];

            mappingTypes.map(mapping => {
                let currentMapping = {}
                if ("orderType" in mapping) {
                    currentMapping = {
                        id: mapping.id,
                        mappingType: {
                            id: mapping.orderType.id,
                            value: mapping.orderType.value
                        },
                        posType: {
                            id: -1,
                            value: '',
                            posId: ''
                        }
                    }

                if (mapping.posOrderType !== undefined && mapping.posOrderType !== null &&
                    mapping.posOrderType.id !== undefined && mapping.posOrderType.id !== null) {

                    currentMapping.posType.id = mapping.posOrderType.id;
                    currentMapping.posType.value = mapping.posOrderType.value;
                    currentMapping.posType.posId = mapping.posOrderType.posId;
                }

                } else if ("tenderType" in mapping) {
                    currentMapping = {
                        id: mapping.id,
                        mappingType: {
                            id: mapping.tenderType.id,
                            value: mapping.tenderType.value
                        },
                        posType: {
                            id: -1,
                            value:'',
                            posId: ''
                        }
                    }
                    if ((mapping.posTenderType !== undefined && mapping.posTenderType !== null &&
                        mapping.posTenderType.id !== undefined && mapping.posTenderType.id !== null) 
                        || (mapping.posTenderType !== undefined && mapping.posTenderType !== null && mapping.posTenderType.id === null && mapping.tenderType.id === -4)) {

                        currentMapping.posType.id = mapping.posTenderType.id;
                        currentMapping.posType.value = mapping.posTenderType.value;
                        currentMapping.posType.posId = mapping.posTenderType.posId;
                    }
                    
                } else if ("chargeType" in mapping) {
                    currentMapping = {
                        id: mapping.id,
                        mappingType: {
                            id: mapping.chargeType.id,
                            value: mapping.chargeType.value
                        },
                        posType: {
                            id: -1,
                            value: '',
                            posId: ''
                        }
                    }

                    if (mapping.posChargeType !== undefined && mapping.posChargeType !== null &&
                        mapping.posChargeType.id !== undefined && mapping.posChargeType.id !== null) {

                        currentMapping.posType.id = mapping.posChargeType.id;
                        currentMapping.posType.value = mapping.posChargeType.value;
                        currentMapping.posType.posId = mapping.posChargeType.posId;
                    }
                }

                newMappings.push(currentMapping);
            });

            this.setState({
                mappings: newMappings,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    changePosTypeState({ target }) {
        const mappingId = target.name === 'giftCard' ? 'Gift card' : Number(target.name);
        const targetValue = Number(target.value);
        const updatedMappings = this.state.mappings.slice();
        updatedMappings.map((mapping) => {
            if ((mapping.id === mappingId) || (mappingId === mapping.mappingType.value)) {
                const posType = this.getPosTypeById(targetValue);

                if (posType !== null) {
                    mapping.posType.id = posType.id;
                    mapping.posType.value = posType.value;
                    mapping.posType.posId = posType.posId;
                }
            }
        });

        this.setState({
            ...this.state,
            mappings: updatedMappings
        });
    }

    transformToLocalize (value) {
        
        switch (value) {
            case "Credit card":
                return i18n.t(`common:paymentTypes.creditCard`);
            case "Cash":
                return i18n.t(`common:paymentTypes.cash`);
            case "Gift card":
                return i18n.t(`screens:restaurantsMainContainer.giftCardLabel`);
            case "Collection":
                return i18n.t('screens:restaurantsMainContainer.collection');
            case "In Store":
                return i18n.t('screens:restaurantsMainContainer.instore');
            case "Delivery":
                return i18n.t('screens:restaurantsMainContainer.delivery');
            case "Curbside":
                return i18n.t('screens:restaurantsMainContainer.curbside');
            default:
                return;
        }
    }

    getPosTypeById(id) {
        let result = null;
        
        this.props.posTypes.map((posType) => {
        if (posType.id === id) {
                result = posType;
            } 
        });
        return result;
    }

    updateMappingType() {
        this.props.update(this.state.mappings);
    }

    renderDivider() {
        const { dividerStyle } = styles;

        return (
            <Row>
                <Col xs={5} style={dividerStyle}>
                </Col>
            </Row>
        );
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon="local_atm" size={22} color="#0288d1" />&nbsp;
                {this.props.translations.heading}
            </div>
        );
    }

    renderLabelFormGroup() {
        const { forGroupMargins, labelStyle } = styles;

        return (
            <FormGroup row style={forGroupMargins}>
                <Col sm={6}>
                    <Label sm="auto" style={labelStyle}>{this.props.translations.firstLabel}</Label>
                </Col>
                <Col sm={6}>
                    <Label sm="auto" style={labelStyle}>{this.props.translations.secondLabel}</Label>
                </Col>
            </FormGroup>
        );
    }



    renderTypeRows() {
        const { forGroupMargins, typeLabel } = styles;
        
        if (this.state.mappings !== undefined && this.state.mappings !== null && this.state.mappings.length > 0) {
            return this.state.mappings.map((mapping, i) => {
                let key = { key: i };
                const isGiftCardMappingType = mapping.mappingType ? mapping.mappingType.id : null;
                let nameValue = (isGiftCardMappingType === -4) ? 'giftCard' : mapping.id;

                return (
                    <FormGroup row {...key} style={forGroupMargins}>
                        <Col sm={6}>
                            <Label style={typeLabel}>{this.transformToLocalize(mapping.mappingType.value)}</Label>
                        </Col>
                        <Col sm={6}>
                            <Input type="select" name={nameValue} id={`posType_${mapping.id}`}
                                value={mapping.posType.value}
                                onChange={this.changePosTypeState}
                            >
                                    <option value={mapping.posType.value}>{mapping.posType.value === 'Collection' ?  i18n.t('screens:restaurantsMainContainer.collection') : mapping.posType.value}</option>
                                {
                                    this.props.posTypes.length > 0 ? this.props.posTypes.map((posType, i) => {
                                        
                                        let isHidden = false;
                                        if (posType.value === mapping.posType.value) {
                                            isHidden = true;
                                        }
                                        return (<option hidden={isHidden} value={posType.id} id={posType.id} key={i}>{posType.value === 'Collection' ?  i18n.t('screens:restaurantsMainContainer.collection') : posType.value}</option>)
                                    }) : <option hidden={true}></option>
                                }
                            </Input>
                        </Col>
                    </FormGroup>
                );
            });
        }
    }


    renderSaveButton() {
        const { saveButtonStyle, spaceBetween, saveButtonStylePixelPoint } = styles;
        let saveButton = saveButtonStyle;

        // Position save button differently when pos is pixelPoint
        const posIsPixelPoint = (this.props.posSettings.type && this.props.posSettings.type.id === 5) && this.props.posSettings.type.value === "Par Pixelpoint";
        if (posIsPixelPoint) saveButton = saveButtonStylePixelPoint;

        return (
            <Button color="primary" style={saveButton} onClick={this.updateMappingType}>
                <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        );
    }

    renderImportButton() {
        const { importButtonStyle, importPadding } = styles;
        const posIsPixelPoint = (this.props.posSettings.type && this.props.posSettings.type.id === 5) && this.props.posSettings.type.value === "Par Pixelpoint";

        return (
            <Button color="primary" style={importButtonStyle} onClick={this.props.import} hidden={posIsPixelPoint}>
                <MaterialIcon icon="autorenew" color="#fff" size={18} /><span style={importPadding}>{i18n.t('common:buttons.import')}</span>
            </Button>
        );
    }

    render() {
        const { containerStyle, errorContainerStyle, formStyle, errorMessage } = styles;

        this.copyStateFromProps();

        if (this.state.stateAlreadyCopiedFromProps === true && Number(this.props.params.id) !== -1 && this.props.posSettings !== null) {
            return (
                <Container fluid style={containerStyle}>
                    <Row>{this.renderHeading()}</Row>
                    <Form style={formStyle}>
                        {this.renderLabelFormGroup()}
                        {this.renderTypeRows()}
                        {this.renderImportButton()}
                        {this.renderSaveButton()}
                    </Form>
                </Container>
            );
        } else {
            if (this.props.posSettings === null || this.props.posSettings === undefined) {
                return (
                    <div style={errorContainerStyle} className="errorIcon">
                        <h5 style={errorMessage}>{i18n.t('common:validations.posUnconfigured')}</h5>
                        <MaterialIcon icon="warning" color="#dbdadb" size={40} />
                    </div>
                );
            } else {
                return (
                    <div style={errorContainerStyle} className="errorIcon">
                        <h5 style={errorMessage}>{i18n.t('common:validations.settingsFirstMsg')}</h5>
                        <MaterialIcon icon="warning" color="#dbdadb" size={40} />
                    </div>
                );
            }
        }
    }
}

export default MappingTypes;

let styles = {
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingBottom: 10,
        paddingTop: 10
    },
    errorContainerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #c93a11',
        paddingBottom: 10,
        paddingTop: 60,
        paddingLeft: 15,
        height: 200,
        textAlign: 'center',
    },
    errorMessage: {
        color: "#c3c3c3",
    },
    formStyle: {
        marginTop: 20
    },
    forGroupMargins: {
        marginLeft: 0,
        marginRight: 20
    },
    buttonColumn: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: 22
    },
    labelStyle: {
        width: '100%',
        backgroundColor: '#cccccc3d',
    },
    margin: {
        marginRight: 12
    },
    typeLabel: {
        paddingLeft: 20,
        marginTop: 10,
        marginBottom: 0
    },
    buttonGroupMargin: {
        marginTop: 30
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    },
    importPadding: {
        paddingLeft: 2
    },
    saveButtonStyle: {
        float: 'right',
        marginRight: 10,
        marginTop: 20,
        marginBottom: 10
    },
    saveButtonStylePixelPoint: {
        float: 'right',
        position: 'relative',
        left: 16,
        marginTop: 20,
        marginBottom: 10
    },
    importButtonStyle: {
        float: 'right',
        marginRight: -15,
        marginTop: 20
    },
    dividerStyle: {
        width: 496,
        marginBottom: 20,
        borderBottom: "1px solid #dee2e6"
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/MappingTypes.js